import { useState } from "react";
import { getAplicacionesFactura } from "../services/facturaService";

export const useAplicacionesFactura = () => {
  const [aplicaciones, setAplicaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAplicaciones = async (idFactura) => {
    try {
      setLoading(true);
      setError(null);

      const data = await getAplicacionesFactura(idFactura);

      setAplicaciones(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setAplicaciones([]);
    setError(null);
    setLoading(false);
  };

  return {
    aplicaciones,
    loading,
    error,
    fetchAplicaciones,
    reset,
  };
};
